export default __webpack_public_path__ + "static/media/login-bg.de0518a9.jpg";